import DOMPurify from "dompurify";

/**
 * Sanitise untrusted HTML before injecting via dangerouslySetInnerHTML or innerHTML.
 * Allows a safe rich-text subset: text formatting, lists, links (with target/rel),
 * images, headings, line breaks. Strips <script>, inline event handlers and
 * javascript: URLs automatically.
 */
const CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "br", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6",
    "hr", "i", "img", "li", "ol", "p", "span", "strong", "u", "ul",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "title", "style", "class"],
  ALLOW_DATA_ATTR: false,
};

// Force external links to open safely
if (typeof window !== "undefined") {
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.getAttribute("href")) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
}

export const sanitizeHtml = (dirty) => {
  if (!dirty) return "";
  return DOMPurify.sanitize(String(dirty), CONFIG);
};

export default sanitizeHtml;
